var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHealth = function SvgHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 100 100",
    preserveAspectRatio: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,93.7c6.9,0,12.5-5.6,12.5-12.5c0-6.9-5.6-12.5-12.5-12.5C5.6,68.7,0,74.3,0,81.2 C0,88.2,5.6,93.7,12.5,93.7 M19.2,75.5l2.2,2.2l-3.1,3.1l-2.2-2.2L19.2,75.5z M10.9,73.4h3.1v4.7h-3.1V73.4z M12.5,81.2 c2,0,3.8,1.2,4.5,3.1h1.8v3.1h-3.1c-0.9,0-1.6-0.7-1.6-1.6s-0.7-1.6-1.6-1.6c-0.9,0-1.5,0.7-1.6,1.5c0,0.9-0.7,1.6-1.6,1.6H6.3 v-3.1h1.8C8.7,82.5,10.5,81.3,12.5,81.2 M5.8,75.5l3.1,3.1l-2.2,2.2l-3.1-3.1L5.8,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6,92.2c8.6,0,15.6-7,15.6-15.6s-7-15.6-15.6-15.6c-8.6,0-15.6,7-15.6,15.6S67.9,92.2,76.6,92.2 M71.1,67.9 L71.1,67.9c1.1-1,2.6-1,3.7,0l1.8,1.7l1.8-1.7c1-0.9,2.6-0.9,3.6,0l0,0c0.9,0.9,1,2.3,0.1,3.3c0,0-0.1,0.1-0.1,0.1l-1.8,1.7 l-3.7,3.5l-3.7-3.5l-1.8-1.7c-0.9-0.9-1-2.3-0.1-3.3C71,68,71,68,71.1,67.9 M68.8,82.8h3.7l1.1-2.3c0.3-0.5,0.7-0.8,1.3-0.9 c0.6,0,1.1,0.2,1.4,0.7l1.6,2.4l0.4-0.7c0.3-0.5,0.8-0.9,1.4-0.9h6.2v3.1h-5.3l-1.1,2.3c-0.2,0.5-0.7,0.8-1.3,0.9c0,0-0.1,0-0.1,0 c-0.5,0-1-0.3-1.3-0.7l-1.6-2.4l-0.4,0.7c-0.3,0.5-0.8,0.9-1.4,0.9h-4.7V82.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8,0c-6,0-10.9,4.9-10.9,10.9c0,6,4.9,10.9,10.9,10.9c6,0,10.9-4.9,10.9-10.9C93.8,4.9,88.9,0,82.8,0M87.3,11.6l-3.1,6.3l-2.8-1.4l2-4h-2.2c-0.9,0-1.6-0.7-1.6-1.6c0-0.2,0.1-0.5,0.2-0.7L83,4l2.8,1.4l-2,4h2.2 c0.9,0,1.6,0.7,1.6,1.6C87.5,11.2,87.4,11.4,87.3,11.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9,21.9c6,0,10.9-4.9,10.9-10.9C21.9,4.9,17,0,10.9,0S0,4.9,0,10.9C0,17,4.9,21.9,10.9,21.9 M4.7,9.4h4.7 V4.7h3.1v4.7h4.7v3.1h-4.7v4.7H9.4v-4.7H4.7V9.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 56.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 62.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 50,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.2,
    y: 50,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.4,
    y: 50,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3,
    y: 40.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 46.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 53.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 40.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.8,
    y: 40.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 40.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 9.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 15.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6,
    y: 10.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6,
    y: 17.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3,31.1L81.3,31.1c0-1.7-1.4-3-3-3c0,0-0.1,0-0.1,0h-8.1c-0.8,3.3-4.2,5.3-7.6,4.5 c-2.2-0.6-3.9-2.3-4.5-4.5h-9.3c2.6-1.8,4.1-4.8,4.1-7.9c0.1-5-3.9-9.2-8.9-9.3s-9.2,3.9-9.3,8.9c0,0.1,0,0.3,0,0.4 c0,3.1,1.5,6.1,4.1,7.9H9.3c-1.6-0.1-3,1.2-3.1,2.8c0,0,0,0.1,0,0.1v0.1c0,1.7,1.4,3.1,3.1,3.1l23.5,3.1v9.8c0.5-0.1,1-0.2,1.6-0.2 c3.5,0,6.3,2.8,6.3,6.3s-2.8,6.3-6.3,6.3c-0.5,0-1.1-0.1-1.6-0.2v29.2c0,2.1,1.7,3.8,3.9,3.8h0.1c2.1,0,3.9-1.7,3.9-3.8V60.9h6.2 v27.4c0,2.1,1.7,3.8,3.9,3.8h0.1c2.1,0,3.9-1.7,3.9-3.8V37.3l23.5-3.1C79.9,34.2,81.2,32.8,81.3,31.1 M45.3,46.9 c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c3.5,0,6.3,2.8,6.3,6.3C51.6,44.1,48.8,46.9,45.3,46.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3,35.9c-2.6,0-4.7,2.1-4.7,4.7c0,2.6,2.1,4.7,4.7,4.7c2.6,0,4.7-2.1,4.7-4.7C50,38,47.9,35.9,45.3,35.9M45.3,42.2c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6C46.9,41.5,46.2,42.2,45.3,42.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1,21.9c-2.6,0-4.7,2.1-4.7,4.7c0,2.6,2.1,4.7,4.7,4.7c2.6,0,4.7-2.1,4.7-4.7C68.7,24,66.7,21.9,64.1,21.9M64.1,28.1c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6C65.6,27.4,64.9,28.1,64.1,28.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4,48.4c-2.6,0-4.7,2.1-4.7,4.7c0,2.6,2.1,4.7,4.7,4.7c2.6,0,4.7-2.1,4.7-4.7C39.1,50.5,37,48.4,34.4,48.4M34.4,54.7c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6C35.9,54,35.2,54.7,34.4,54.7"
  }))));
};

export default __webpack_public_path__ + "static/media/Health.cf0a5c18.svg";
export { SvgHealth as ReactComponent };